(function($) {

	$.fn.msxiReset = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.msxiReset.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            // Do the work here
            $this.click(function(){
                $(eOpts['target']).find(':input').each(function(){
                    var $input = $(this);
                    var data = $input.metadata();
                    var defaultVal = data['default-val'];
                    if(defaultVal) {
                        $input.val(defaultVal);
                        $input.trigger('change');
                    }
                });
            });
        });
	};
	//
	// plugin defaults
	//
	$.fn.msxiReset.defaults = {
		'target': 'body'
	};

})(jQuery);